import { render, staticRenderFns } from "./PaymentGatewayModal.vue?vue&type=template&id=040fd376&scoped=true&"
import script from "./PaymentGatewayModal.vue?vue&type=script&lang=js&"
export * from "./PaymentGatewayModal.vue?vue&type=script&lang=js&"
import style0 from "./PaymentGatewayModal.vue?vue&type=style&index=0&id=040fd376&scoped=true&lang=css&"
import style1 from "./PaymentGatewayModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040fd376",
  null
  
)

export default component.exports